import { OrderState, ShippingOptions } from './checkoutState';

const getAvailableDeliveryTypes = (shippingOptions: ShippingOptions) =>
  Object.entries({
    homeDelivery: !!shippingOptions.homeDelivery?.filter(({ isDisabled }) => !isDisabled).length,
    collectionPoint: !!shippingOptions.collectionPointDelivery?.filter(
      ({ isDisabled, collectionPointType }) => !isDisabled && collectionPointType !== 'generic'
    ).length,
    storePickup: !!shippingOptions.collectionPointDelivery?.filter(
      ({ isDisabled, collectionPointType }) => !isDisabled && collectionPointType === 'generic'
    ).length,
  })
    .filter(([, value]) => !!value)
    .map(([key]) => key);

export const getInitialDeliveryType = (orderState: OrderState, shippingOptions?: ShippingOptions) => {
  const isHomeDelivery =
    !shippingOptions || (!!orderState.addresses?.shipping && !orderState.addresses.shipping.collectionPoint);
  const isCollectionPoint =
    !!orderState.addresses?.shipping?.collectionPoint &&
    orderState.shipping?.selected?.[0].collectionPointType !== 'generic';
  const isStorePickup =
    !!orderState.addresses?.shipping?.collectionPoint &&
    orderState.shipping?.selected?.[0].collectionPointType === 'generic';
  return isHomeDelivery
    ? 'homeDelivery'
    : isCollectionPoint
    ? 'collectionPoint'
    : isStorePickup
    ? 'storePickup'
    : getAvailableDeliveryTypes(shippingOptions)[0];
};

export default getAvailableDeliveryTypes;
